import React, { useEffect } from 'react';
import { LeadFormProvider } from './components/LeadFormContext';
import { LeadFormModal } from './components/LeadFormModal';
import { initMetaPixel } from './components/metaPixel';
import { HeroSection } from './components/sections/HeroSection';
import { ProductCards } from './components/sections/ProductCards';
import { WhyUs } from './components/sections/WhyUs';
import { HowItWorks } from './components/sections/HowItWorks';
import { PriceComparison } from './components/sections/PriceComparison';
import { PromoBanner } from './components/sections/PromoBanner';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCta } from './components/sections/FinalCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LeadFormProvider data-id="element-0">
      <div className="w-full min-h-screen bg-[#0A1A3F]" data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProductCards data-id="element-3" />
        <WhyUs data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <PriceComparison data-id="element-6" />
        <PromoBanner data-id="element-7" />
        <FaqSection data-id="element-8" />
        <FinalCta data-id="element-9" />

        <LeadFormModal data-id="element-10" />
      </div>
    </LeadFormProvider>;
}